import type { PackingListRow } from "@RequestFormV2/sections/PackingList/types";
import { isContainerRow } from "@RequestFormV2/sections/PackingList/utils/packingListSplit";
import { isPackingListRowEmpty } from "@RequestFormV2/sections/PackingList/utils/isRowEmpty";

/** At least one non-empty handling-unit (non-container) row exists. */
export function hasParcelHandlingUnit(rows: PackingListRow[] | undefined): boolean {
  return (rows ?? []).some((row) => !isContainerRow(row) && !isPackingListRowEmpty(row));
}
